var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeIgnoraRedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hombres",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8004",
    "data-name": "Rectangle 8004",
    width: 60,
    height: 60,
    fill: "#c0e4d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8002",
    "data-name": "Rectangle 8002",
    width: 59,
    height: 59,
    transform: "translate(0.562 0.178)",
    fill: "#de5e60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8115",
    "data-name": "Rectangle 8115",
    width: 30,
    height: 44.907,
    transform: "translate(-2 -3)",
    fill: "#d1484b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8940",
    "data-name": "Group 8940",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8939",
    "data-name": "Group 8939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8938",
    "data-name": "Group 8938",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8937",
    "data-name": "Group 8937",
    opacity: 0.258,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8936",
    "data-name": "Group 8936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8935",
    "data-name": "Group 8935",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21867",
    "data-name": "Path 21867",
    d: "M30.062.178a29.5,29.5,0,1,1-29.5,29.5,29.5,29.5,0,0,1,29.5-29.5",
    fill: "#de5e60"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10868",
    "data-name": "Group 10868",
    transform: "translate(17 10.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9021",
    "data-name": "Group 9021",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-help-circle",
    "data-name": "Icon feather-help-circle",
    transform: "translate(-1.138 5.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24047",
    "data-name": "Path 24047",
    d: "M25.275,14.138A11.138,11.138,0,1,1,14.138,3,11.138,11.138,0,0,1,25.275,14.138Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24048",
    "data-name": "Path 24048",
    d: "M13.635,12.726a3.341,3.341,0,0,1,6.493,1.114c0,2.228-3.341,3.341-3.341,3.341",
    transform: "translate(-2.738 -1.929)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24049",
    "data-name": "Path 24049",
    d: "M18,25.5h0",
    transform: "translate(-3.862 -5.793)",
    fill: "none",
    stroke: "#d1484b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeIgnoraRedIcon);
export default __webpack_public_path__ + "static/media/seIgnora_red_icon.15028651a6c4a6a177f5d9eddf7cf316.svg";
export { ForwardRef as ReactComponent };